import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Box, InputAdornment, TextField, Typography } from '@mui/material';
import { Email as EmailIcon, VpnKey as KeyIcon } from '@mui/icons-material';
import AppDialog from '../AppDialog';

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export default function PasswordResetModal(props) {
    const {open, close, loading, handleSubmitReset} = props;

    const[email, setEmail] = useState('');
    const [emailError, setEmailError] = useState('');

    function handleSubmit() {
        if (!email) {
            setEmailError('Email address is required');
            return;
        }
        if (!EMAIL_PATTERN.test(email)) {
            setEmailError('Please enter a valid email address');
            return;
        }
        setEmailError('');
        handleSubmitReset(email);
    }

    function handleEmailChange(event) {
        setEmail(event.target.value);
        if (emailError) {
            setEmailError('');
        }
    }

    // start clean each time the dialog is opened
    useEffect(() => {
        if (open) {
            setEmail('');
            setEmailError('');
        }
    }, [open]);

    const title = (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: 48,
                    height: 48,
                    borderRadius: '50%',
                    flexShrink: 0,
                    color: 'primary.contrastText',
                    background: (theme) =>
                        `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
                }}
            >
                <KeyIcon />
            </Box>
            <Box>
                <Typography variant='h5' sx={{ fontWeight: 700 }}>Reset Password</Typography>
                <Typography variant='body2' color='text.secondary'>
                    Enter your email to receive reset instructions
                </Typography>
            </Box>
        </Box>
    );

    return(
        <AppDialog
            open={open}
            onClose={close}
            title={title}
            onSubmit={handleSubmit}
            submitText={loading ? 'Sending...' : 'Send Reset Link'}
            submitDisabled={!email}
            busy={loading}
        >
            <TextField
                fullWidth
                autoFocus
                required
                type='email'
                label='Email Address'
                placeholder='Enter your email address'
                value={email}
                onChange={handleEmailChange}
                error={!!emailError}
                helperText={emailError}
                InputProps={{
                    startAdornment: (
                        <InputAdornment position='start'>
                            <EmailIcon color='action' />
                        </InputAdornment>
                    ),
                }}
            />
        </AppDialog>
    );
}

PasswordResetModal.propTypes = {
    open: PropTypes.bool.isRequired,
    close: PropTypes.func.isRequired,
    loading: PropTypes.bool.isRequired,
    handleSubmitReset: PropTypes.func.isRequired,
};